import { fireToast } from "../services/sweetAlertConfig";

export function CheckAlert() {
  const message = localStorage.getItem("message");
  if (message) {
    fireToast(message);
    localStorage.removeItem("message");
  }
}
